import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { dummyImages } from "../utils/dummyImages";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Typography } from "@mui/material";
import { FlexColCenter } from "./FlexBox";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/plugins/counter.css";

const PropertyImageGallery = ({ images = null }) => {
   const [open, setOpen] = React.useState(false);
   const [startIndex, setStartIndex] = React.useState(0);

   // Use provided images or fallback to dummy images
   const displayImages = images || dummyImages;

   const handleSlider = (index) => {
      setOpen(true);
      setStartIndex(index)
   }

   // If no images, show placeholder
   if (displayImages.length === 0) {
      return (
         <Box sx={{ width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f5f5f5" }}>
            <img src="/images/rent-beta.png" alt="No images available" style={{ maxWidth: "300px", maxHeight: "300px" }} />
         </Box>
      );
   }

	return (
		<>
			<Swiper navigation={true} modules={[Navigation]} className="mySwiper">
				{displayImages.map((value, index) => {
					return (
						<SwiperSlide key={index}>
							<img
								style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "contain" }}
								src={value.src}
								alt="house images"
								onClick={() => handleSlider(index)}
							/>
						</SwiperSlide>
					);
				})}
			</Swiper>
			<Grid container spacing={2}>
				{displayImages.slice(0, 5).map((value, index) => {
					return (
						<Grid key={index} sx={{ cursor: "pointer", display: { xs: "none", sm: "block" } }} sm={2}>
							<img style={{ borderRadius: "5px", width: "100%", height: "auto" }} className="swiper-slide" src={value.src} alt="house images" onClick={() => handleSlider(index)} />
						</Grid>
					);
				})}
				{displayImages.length > 5 && (
					<Grid sx={{ display: { xs: "none", sm: "block" } }} sm={2}>
						<FlexColCenter
							sx={{
								borderRadius: "5px",
								width: "100%",
								height: "100%",
								backgroundImage: displayImages[5]?.src 
									? `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${displayImages[5].src})`
									: "linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7))",
								backgroundSize: "cover",
								backgroundPosition: "center",
								cursor: "pointer",
							}}
							onClick={() => handleSlider(5)}
						>
							<Typography sx={{ color: "white" }} variant="h5">
								{displayImages.length - displayImages.slice(0, 5).length}
							</Typography>
							<Typography sx={{ color: "white" }} variant="h6">
								More Photos
							</Typography>
						</FlexColCenter>
					</Grid>
				)}
			</Grid>
			<Lightbox
				open={open}
				close={() => setOpen(false)}
				slides={displayImages}
				plugins={[Counter]}
				counter={{ container: { style: { top: 0, bottom: "unset" } } }}
				index={startIndex}
			/>
		</>
	);
};

export default PropertyImageGallery;
